import { Box, Typography, Grid, LinearProgress, Backdrop, CircularProgress, Rating } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import DASHBOARD_CHART_GREEN_ICON from '../../assets/images/dashboard_chart_green_icon.svg';
import DASHBOARD_CHART_BLUE_ICON from '../../assets/images/dashboard_chart_blue_icon.svg';
import DASHBOARD_CHART_ORANGE_ICON from '../../assets/images/dashboard_chart_orange_icon.svg';
import DASHBOARD_CHART_RED_ICON from '../../assets/images/dashboard_chart_red_icon.svg';
import CardSaleReport from "./components/CardSaleReport";
import SwitchComponent from "../../components/switch";
import PRODUCT_MANAGEMENT_ICON from '../../assets/images/drawer_icons/product.svg';
import CATEGORY_MANAGEMENT_ICON from '../../assets/images/drawer_icons/category_management.svg';
import { useNavigate } from "react-router-dom";
import { CATEGORIES_ROUTE, ORDER_ROUTE, PRODUCT_ROUTE, SALES_REPORT_ROUTE } from "../../routes/paths";
import { useHomeController } from "./controller";
import { numberFormat } from "../../utils/nunberFormat";
import { useTranslation } from "react-i18next";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";

const HomeView = () => {
    const navigate = useNavigate();
    const controller = useHomeController();
    const { t, i18n } = useTranslation("global");
    return <Box>
        {
            !controller.loading
                ?
                <Box>
                    <Box mb={5} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                        <Typography color="#737373" fontSize="32px">{i18n.language === EN_ACCEPT_LANGUAGE ? controller.dataMerchantStore?.nameEn : controller.dataMerchantStore?.nameLa}</Typography>
                        <Rating name="half-rating-read" defaultValue={controller.dataMerchantStore?.rate} precision={0.5} readOnly />
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SwitchComponent value={controller.openMerchantStore} onChange={controller.handleMerchantStoreChange} />
                            <Typography>{t("home_page.Close / Open Shop")}</Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("home_page.Sale Report")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;<span style={{ color: '#11A2F1', cursor: 'pointer' }} onClick={() => navigate(SALES_REPORT_ROUTE)}>{t("home_page.Sell all")} {'>'}</span></Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Total sale")} currency={t("Kip") || ""} amount={controller.dataOrderReport?.totalSale} icon={DASHBOARD_CHART_GREEN_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Completed")} amount={controller.dataOrderReport?.completedSale} icon={DASHBOARD_CHART_BLUE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Partially completed")} amount={controller.dataOrderReport?.partiallyCompletedSale} icon={DASHBOARD_CHART_ORANGE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Return")} amount={controller.dataOrderReport?.returnSale} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Failed")} amount={controller.dataOrderReport?.failedSale} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={5}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("home_page.My Order")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;<span style={{ color: '#11A2F1', cursor: 'pointer' }} onClick={() => navigate(ORDER_ROUTE)}>{t("home_page.Sell all")} {'>'}</span></Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Customer order")} amount={controller.dataOrderReport?.customerOrder} icon={DASHBOARD_CHART_GREEN_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("To pack")} amount={controller.dataOrderReport?.toPackOrder} icon={DASHBOARD_CHART_BLUE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("To ship")} amount={controller.dataOrderReport?.toShipOrder} icon={DASHBOARD_CHART_ORANGE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("Shipping")} amount={controller.dataOrderReport?.shippingOrder} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={5}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("home_page.Shortcut")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;</Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <Box
                                    sx={{
                                        background: "var(--primary-lighter, #C8FACD)",
                                        borderRadius: "16px",
                                        maxWidth: "auto",
                                        padding: 2,
                                        display: 'flex',
                                        flexDirection: "column",
                                        alignItems: 'center',
                                        cursor: "pointer"
                                    }}
                                    onClick={() => navigate(PRODUCT_ROUTE)}
                                >

                                    <img src={PRODUCT_MANAGEMENT_ICON} alt="" style={{
                                        width: "30px",
                                        height: "30px",
                                        marginTop: 20
                                    }}
                                    />
                                    <Typography sx={{
                                        color: "var(--primary-darker, #005249)",
                                        textAlign: 'center',
                                        fontWeight: "bold",
                                        fontSize: "32px",
                                        marginTop: 3

                                    }}>{numberFormat(controller.countProductTotal)}</Typography>
                                    <Typography sx={{ mb: 5, fontSize: "14px", color: "var(--primary-darker, #005249)" }}>{t("home_page.Product management")}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Box
                                    sx={{
                                        background: "var(--info-lighter, #CAFDF5)",
                                        borderRadius: "16px",
                                        maxWidth: "auto",
                                        padding: 2,
                                        display: 'flex',
                                        flexDirection: "column",
                                        alignItems: 'center',
                                        cursor: "pointer"
                                    }}
                                    onClick={() => navigate(CATEGORIES_ROUTE)}
                                >

                                    <img src={CATEGORY_MANAGEMENT_ICON} alt="" style={{
                                        width: "30px",
                                        height: "30px",
                                        marginTop: 20
                                    }}
                                    />
                                    <Typography sx={{
                                        color: "var(--info-darker, #003768)",
                                        textAlign: 'center',
                                        fontWeight: "bold",
                                        fontSize: "32px",
                                        marginTop: 3

                                    }}>{numberFormat(controller.countCategoryTotal)}</Typography>
                                    <Typography sx={{ mb: 5, fontSize: "14px", color: "var(--info-darker, #003768)" }}>{t("home_page.Category management")}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={controller.loadingMerchantStoreChange}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Box>

                :
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LoadingAnimatedIcon />
                </Box>
        }
    </Box>

}
export default HomeView;